// extracted by mini-css-extract-plugin
var _1 = "mKmin_ZBQGUgxcAFZfw1";
var _2 = "FOCTJMCR8J2neU6p0D8N";
var _3 = "WIh7QzsL_zkTY9frfTEV";
var _4 = "q6VqiPNtaPOwsuUC6_1w";
var _5 = "UEbvz2O1YKfC6wB7unyR";
export { _1 as "button", _2 as "controls", _3 as "input", _4 as "uploadGuideTip", _5 as "wrapper" }
